<template>
  <div
    v-if="applicantProfile && applicantSkillGroups"
    id="applicant-edit-tab-personal-data"
  >
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-tabs
          v-if="
            applicantSkillGroups.results && applicantSkillGroups.results.length
          "
        >
          <vs-tab
            v-for="item in applicantSkillGroups.results"
            :key="item.id"
            :label="item.name"
          >
            <SkillCategory v-model="item.id" :profile-id="profileId" />
          </vs-tab>
        </vs-tabs>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="vx-row">
      <div class="vx-col w-full">
        Noch keine Berufskategorie hinterlegt. Bitte unter Intern,
        Berufskategorie hinterlegen.
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import SkillCategory from "../form/skills/SkillCategory.vue";

export default {
  components: {
    SkillCategory
  },
  props: {
    profileId: { type: String, required: true }
  },
  data() {
    return {
      fetchFailed: false
    };
  },
  apollo: {
    applicantProfile: {
      query: gql`
        query ApplicantProfile($id: ID!) {
          applicantProfile(id: $id) {
            id
            skillJobType {
              id
            }
          }
        }
      `,
      fetchPolicy: "network-only",
      variables() {
        return {
          id: this.profileId
        };
      }
    },
    applicantSkillGroups: {
      query: gql`
        query($jobId: ID!) {
          applicantSkillGroups(jobType: $jobId, page: 1) {
            results {
              id
              name
            }
          }
        }
      `,
      skip() {
        return !(this.applicantProfile && this.applicantProfile.skillJobType);
      },
      fetchPolicy: "network-only",
      variables() {
        return {
          jobId: this.applicantProfile.skillJobType.id
        };
      }
    }
  }
};
</script>
